import { GetFunc } from "../../types";

export const getMapOptions = (getWidth: GetFunc, getHeight: GetFunc) => ({
  map: {
    from: {
      top: getHeight(-404),
      left: getWidth(-675),
      transform: "rotate(48deg)"
    },
    to: [
      {
        top: getHeight(-404),
        left: getWidth(-600),
        transform: "rotate(-12deg)",
        delay: 3500,
        config: {
          duration: 3900
        }
      }
    ],
    loop: {
      from: {
        top: getHeight(-404),
        left: getWidth(-675),
        transform: "rotate(48deg)"
      },
      delay: 300,
    },
  },
  car: {
    lightingColor: "#47B4E3",
    label: "2022 Tesla",
    color: "#47B4E3",
    wrapper: {
      from: {
        top: getHeight(480),
        left: getWidth(600),
        transform: "rotate(-48deg)"
      },
      to: [
        {
          top: getHeight(496),
          left: getWidth(621),
          transform: "rotate(-38deg)",
          delay: 3500,
          config: {
            duration: 650
          },
        },
        {
          top: getHeight(513),
          left: getWidth(637),
          transform: "rotate(-28deg)",
          config: {
            duration: 650
          },
        },
        {
          top: getHeight(534),
          left: getWidth(648),
          transform: "rotate(-18deg)",
          config: {
            duration: 650
          },
        },
        {
          top: getHeight(555),
          left: getWidth(655),
          transform: "rotate(-8deg)",
          config: {
            duration: 650
          },
        },
        {
          top: getHeight(579),
          left: getWidth(660),
          transform: "rotate(2deg)",
          config: {
            duration: 650
          }
        },
        {
          top: getHeight(603),
          left: getWidth(662),
          transform: "rotate(12deg)",
          config: {
            duration: 650
          }
        }
      ],
      loop: {
        from: {
          top: getHeight(480),
          left: getWidth(600),
          transform: "rotate(-48deg)"
        },
        delay: 300
      },
    },
    icon: {
      from: {
        transform: "rotate(180deg)"
      }
    }
  }
});